import Api from "../axios";

export default async function apiInTimeReport(
    startDate,
    endDate,
    currentEmployeeId
) {
    return await Api.get(
        `/taskboard_leave_list?start_date=${startDate}&end_date=${endDate}&employee_id=${currentEmployeeId}`
    );
}
